import React from "react";

const FooterListTitle = ({ title }) => {
  return (
    <h2 
      className="text-xl font-bodyFont font-semibold mb-6" 
      aria-label={`RK Global Trader ${title} section`}
    >
      {title}
    </h2>
  );
};

export default FooterListTitle;
